export default 'ffffffff-ffff-ffff-ffff-ffffffffffff';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/node_modules/uuid/dist/esm-browser/max.js
// module id = 2275
// module chunks = 0